type BaseEvent = { type: string };

export type ExtractByType<T extends BaseEvent, K extends T["type"]> = Extract<
  T,
  { type: K }
>;

export class PubSub<T extends BaseEvent> {
  private subscribers: {
    [K in T["type"]]?: ((data: ExtractByType<T, K>) => void)[];
  } = {};

  subscribe<K extends T["type"]>(
    type: K,
    callback: (data: ExtractByType<T, K>) => void,
  ): () => void {
    if (!this.subscribers[type]) {
      this.subscribers[type] = [];
    }
    this.subscribers[type].push(callback);

    return () => {
      const subs = this.subscribers[type];
      if (subs) {
        const index = subs.indexOf(callback);
        if (index > -1) {
          subs.splice(index, 1);
        }
      }
    };
  }

  publish(event: T): void {
    const subs = this.subscribers[event.type as T["type"]];
    if (subs) {
      for (const callback of subs) {
        callback(event as ExtractByType<T, T["type"]>);
      }
    }
  }

  clear(): void {
    this.subscribers = {};
  }
}
